import { GoFeralAuthClient } from './clients/GoFeralAuthClient';
import { SessionStore } from './stores/sessions/SessionStore';
import { computed, when } from 'mobx';
import { NotificationStore } from './stores/NotificationStore';
import { DialogStore } from './stores/DialogStore';
import { APP_ENV } from '../env';

export class System {
  auth_client: GoFeralAuthClient;

  // uI things
  notification_store: NotificationStore;
  dialog_store: DialogStore;

  session_store: SessionStore;

  constructor() {
    this.auth_client = new GoFeralAuthClient({
      url: APP_ENV.AUTH_SERVER
    });
    this.notification_store = new NotificationStore();
    this.dialog_store = new DialogStore();

    this.session_store = new SessionStore({
      auth_client: this.auth_client,
      notification_store: this.notification_store
    });
  }

  @computed get user_store() {
    return this.session_store.current_session.user_store;
  }

  @computed get pack_store() {
    return this.session_store.current_session.pack_store;
  }

  @computed get group_store() {
    return this.session_store.current_session.group_store;
  }

  @computed get session() {
    return this.session_store.current_session;
  }

  @computed get user() {
    return this.session?.user;
  }

  async waitForUser() {
    await when(() => !!this.user?.loaded);
  }

  init() {
    this.session_store.init();
  }
}
